/* PawRegal CRO layer (2026-11-01). Decisions CRO1..CRO12 in copy/decisions.md.
   1. Floating checkout button (#pr-fab): shows when the drawer is closed and the cart has items. Main tap -> /checkout,
      cart icon tap / long-press / right-click -> opens the drawer. Hidden on the cart page, when the cart is empty, when the
      drawer is open, and when the cart is add-on only (checkout is blocked there, so it opens the drawer instead).
      On mobile PDPs it sits above the sticky CTA (#pr-sticky.is-on) instead of covering it.
   2. Delivery estimate ([data-pr-eta]): "Order today, estimated arrival Nov 9 to Nov 17". Business days from
      data-min/data-max (policy.yaml delivery_estimate), counted from the next US business day in America/New_York,
      skipping weekends and carrier holidays. Shown only while standard shipping still reaches Dec 25 (data-cutoff). */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  var fmt; try { fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }); } catch (e) { fmt = { format: function (n) { return '$' + n.toFixed(2); } }; }
  function money(cents) { return fmt.format((cents || 0) / 100); }

  /* ---------- delivery estimate ---------- */
  var HOLIDAYS = ['2026-11-26', '2026-12-25', '2027-01-01'];
  function etParts(d) {
    var p = {}; new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' })
      .formatToParts(d).forEach(function (x) { p[x.type] = x.value; });
    return new Date(Date.UTC(+p.year, +p.month - 1, +p.day));
  }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function isBiz(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && HOLIDAYS.indexOf(iso(d)) < 0; }
  function addBiz(d, n) { var x = new Date(d); while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (isBiz(x)) n--; } return x; }
  function label(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' }); }
  function fillEta(scope) {
    (scope || document).querySelectorAll('[data-pr-eta]:not([data-done])').forEach(function (el) {
      el.setAttribute('data-done', '1');
      var min = +el.getAttribute('data-min') || 5, max = +el.getAttribute('data-max') || 11;
      var today = etParts(new Date()), cutoff = el.getAttribute('data-cutoff');
      if (cutoff && iso(today) > cutoff) return; // after the standard cutoff the promise strip takes over (express / digital)
      var a = addBiz(today, min), b = addBiz(today, max);
      var t = el.querySelector('[data-pr-eta-text]') || el;
      t.textContent = 'Order today, estimated arrival ' + label(a) + ' to ' + label(b) + '.';
      el.hidden = false;
    });
  }

  /* ---------- floating checkout ---------- */
  var fab = document.getElementById('pr-fab');
  var drawer = document.querySelector('cart-drawer');
  var state = { count: 0, total: 0 };
  function blocked() { return !!(drawer && drawer.querySelector('[data-pr-addon-only]')); }
  function onPdpSticky() { var s = document.getElementById('pr-sticky'); return s && s.classList.contains('is-on') && getComputedStyle(s).display !== 'none' ? s : null; /* fixed elements have no offsetParent */ }
  function place() {
    if (!fab) return;
    var s = onPdpSticky();
    fab.style.setProperty('--pr-fab-lift', s ? (s.getBoundingClientRect().height + 10) + 'px' : '0px');
    tuck();
  }
  // Never cover a primary action (PDP add-to-cart, wallet buttons, upload box, preview tiles): tuck away while one sits under it.
  var AVOID = '#pr-add, .pr-btn, .button, .shopify-payment-button, .pp-drop, .pp-tile, .pp-xs, input, textarea, select';
  function tuck() {
    if (!fab || !fab.classList.contains('is-on')) return;
    var r = fab.getBoundingClientRect(), y = r.top + r.height / 2, hit = false;
    [r.left + 6, r.left + r.width / 2, r.right - 6].forEach(function (x) {
      if (hit) return;
      (document.elementsFromPoint ? document.elementsFromPoint(x, y) : []).forEach(function (el) {
        if (!hit && !fab.contains(el) && el.closest && el.closest(AVOID)) hit = true;
      });
    });
    fab.classList.toggle('is-tucked', hit);
  }
  var raf = 0;
  window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; tuck(); }); }, { passive: true });
  function render() {
    if (!fab) return;
    var hide = !state.count || (drawer && drawer.classList.contains('active')) || fab.hasAttribute('data-off');
    var n = state.count + ' item' + (state.count === 1 ? '' : 's');
    fab.querySelector('[data-fab-count]').textContent = state.count;
    fab.querySelector('[data-fab-total]').textContent = money(state.total);
    var go = fab.querySelector('.pr-fab__go'), cart = fab.querySelector('.pr-fab__cart');
    go.setAttribute('aria-label', blocked() ? 'Open cart, ' + n + ', ' + money(state.total) : 'Checkout, ' + n + ', total ' + money(state.total));
    cart.setAttribute('aria-label', 'Open cart, ' + n);
    fab.classList.toggle('is-on', !hide);
    fab.setAttribute('aria-hidden', hide ? 'true' : 'false');
    [go, cart].forEach(function (b) { if (hide) b.setAttribute('tabindex', '-1'); else b.removeAttribute('tabindex'); });
    place();
  }
  function refresh() {
    fetch(root + 'cart.js', { headers: { accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { state.count = c.item_count; state.total = c.total_price; render(); })
      .catch(function () {});
  }
  function openDrawer(from) { if (drawer && drawer.open) drawer.open(from); else window.location.href = root + 'cart'; }
  if (fab) {
    state.count = +fab.getAttribute('data-count') || 0; state.total = +fab.getAttribute('data-total') || 0;
    var go = fab.querySelector('.pr-fab__go'), cartBtn = fab.querySelector('.pr-fab__cart');
    var timer = null, longFired = false;
    cartBtn.addEventListener('click', function () { openDrawer(cartBtn); });
    go.addEventListener('pointerdown', function () { longFired = false; clearTimeout(timer); timer = setTimeout(function () { longFired = true; openDrawer(go); }, 550); });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (e) { go.addEventListener(e, function () { clearTimeout(timer); }); });
    go.addEventListener('contextmenu', function (e) { e.preventDefault(); clearTimeout(timer); if (!longFired) openDrawer(go); longFired = true; });
    go.addEventListener('click', function (e) {
      if (longFired || blocked()) { e.preventDefault(); if (!longFired) openDrawer(go); longFired = false; return; }
      go.classList.add('is-busy');
    });
    var deb = null;
    if (drawer) new MutationObserver(function (muts) {
      var cls = muts.some(function (m) { return m.type === 'attributes'; });
      if (cls) render();
      if (muts.some(function (m) { return m.type === 'childList'; })) { clearTimeout(deb); deb = setTimeout(function () { refresh(); fillEta(drawer); }, 120); }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    var st = document.getElementById('pr-sticky');
    if (st) new MutationObserver(place).observe(st, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', place, { passive: true });
    window.addEventListener('pageshow', function (e) { go.classList.remove('is-busy'); if (e.persisted) refresh(); });
    render();
  }
  fillEta(document);
  window.PRcro = { refresh: refresh, fillEta: fillEta };
})();
